import React from 'react';
import { Box, Tooltip } from '@mui/material';

// Kolory atramentu w Lorcana z ikonami
const inkColors = [
    { value: 'Amber', label: 'Amber', color: '#f59e0b', icon: '/icons/ink-amber.webp' },
    { value: 'Amethyst', label: 'Amethyst', color: '#8b5cf6', icon: '/icons/ink-amethyst.webp' },
    { value: 'Steel', label: 'Steel', color: '#6b7280', icon: '/icons/ink-steel.webp' },
    { value: 'Ruby', label: 'Ruby', color: '#ef4444', icon: '/icons/ink-ruby.webp' },
    { value: 'Sapphire', label: 'Sapphire', color: '#3b82f6', icon: '/icons/ink-sapphire.webp' },
    { value: 'Emerald', label: 'Emerald', color: '#10b981', icon: '/icons/ink-emerald.webp' }
];

function InkColorIcon({
    color,
    size = 24,
    showLabel = false,
    tooltip = true,
    circular = false,
    sx = {}
}) {
    const colorData = inkColors.find(c => c.value.toLowerCase() === (color || '').toLowerCase());

    if (!colorData) {
        return null;
    }

    const iconElement = (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: showLabel ? 0.5 : 0,
                ...(circular && {
                    p: 1,
                    border: `2px solid ${colorData.color}`,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(124, 58, 237, 0.2)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'scale(1.1)',
                        boxShadow: `0 0 15px ${colorData.color}40`
                    }
                }),
                ...sx
            }}
        >
            <img
                src={colorData.icon}
                alt={colorData.label}
                style={{
                    width: size,
                    height: size,
                    ...(sx.imgStyle || {})
                }}
            />
            {showLabel && (
                <span style={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: `${size * 0.6}px`
                }}>
                    {colorData.label}
                </span>
            )}
        </Box>
    );

    if (tooltip) {
        return (
            <Tooltip title={colorData.label} arrow>
                {iconElement}
            </Tooltip>
        );
    }

    return iconElement;
}

// Komponent do wyświetlania wielu kolorów atramentu
function InkColorIcons({
    colors,
    size = 24,
    showLabels = false,
    tooltip = true,
    gap = 0.5,
    circular = false,
    sx = {}
}) {
    if (!colors || colors.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                gap: gap,
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                ...sx
            }}
        >
            {colors.map((color, index) => (
                <InkColorIcon
                    key={index}
                    color={color}
                    size={size}
                    showLabel={showLabels}
                    tooltip={tooltip}
                    circular={circular}
                />
            ))}
        </Box>
    );
}

// Hook do pobierania danych koloru
export const useInkColor = (colorName) => {
    return inkColors.find(c => c.value.toLowerCase() === (colorName || '').toLowerCase()) || null;
};

// Eksport wszystkich kolorów
export const getAllInkColors = () => inkColors;

export default InkColorIcon;
export { InkColorIcons };
